const product = (id, icon, name, description, about) => ({
    id,
    icon,
    name,
    description,
    cta: {
        text: {
            pt: 'TENHO INTERESSE',
            en: 'I\'M INTERESTED',
        },
        href: '#contact-us'
    },
    about
});

const productsDetails = [
    {
        id: 'digital-advisor',
        icon: 'idea', 
        name: { pt: 'Digital Advisor',en: 'Digital Advisor'}, 
        description: {
            pt: 'Transforme sua estratégia digital com a orientação de nossos especialistas. Oferecemos insights valiosos para maximizar seu potencial de mercado.', 
            en: 'Transform your digital strategy with guidance from our experts. We provide valuable insights to maximize your market potential.'
        },
        about: 6
    },
    {
        id: 'express-solutions',
        icon: 'code-chat', 
        name: { pt: 'Soluções Expressas',en: 'Express Solutions'}, 
        description: {
            pt: 'Soluções rápidas e eficientes para as necessidades mais urgentes da sua empresa. Atenda às demandas do mercado com agilidade e precisão.', 
            en: `Fast and efficient solutions for your company's most urgent needs. Meet market demands with agility and precision.`
        },
        about: 4
    },
    {
        id: 'digital-development',
        icon: 'laptop', 
        name: { pt: 'Desenvolvimento Digital',en: 'Digital Development'}, 
        description: {
            pt: 'Transforme suas ideias em realidade com nossas soluções avançadas de desenvolvimento digital.', 
            en: 'Turn your ideas into reality with our advanced digital development solutions.'
        },
        about: 1
    },
    {
        id: 'tech-support',
        icon: 'settings', 
        name:  { pt: 'Apoio Tecnológico',en: 'Technological Support'}, 
        description: {
            pt: 'Receba suporte tecnológico contínuo e mantenha suas operações funcionando sem problemas com a nossa assistência especializada.', 
            en: 'Receive continuous technological support and keep your operations running smoothly with our specialized assistance.'
        },
        about: 5
    },
    {
        id: 'talent-hub',
        icon: 'star', 
        name:  { pt: 'Hub de Talentos', en: 'Talent Hub'}, 
        description: {
            pt: 'Ter o melhor time é o que muda indicador de verdade. Nosso Hub de Talentos é onde os diamantes lapidados se encontram para apoiar suas necessidades.', 
            en: 'Having the best team is what makes the difference. Our Talent Hub is where polished diamonds come together to support your needs.'
        },
        about: 2
    }
    
];

export default [
    {
        id: 'acceleration',
        colorClass: '.vivid02',
        bannerText: {
            pt: 'ACELERAR. INOVAR. REIVENTAR. DESTACAR. INSPIRAR.',
            en: 'ACCELERATE. INNOVATE. REINVENT. STAND OUT. INSPIRE.'
        },
        infos: [
            {
                title: {
                    pt: '+100M',
                    en: '+100M',
                },
                content: {
                    pt: 'Faturamento gerado com nossas soluções.',
                    en: 'Revenue generated with our solutions.',
                }
            },
            {
                title: {
                    pt: '+300',
                    en: '+300',
                },
                content: {
                    pt: 'Ideias dos nossos clientes no mercado.',
                    en: 'Client ideas brought to market.',
                }
            },
            {
                title: {
                    pt: '2 meses',
                    en: '2 months',
                },
                content: {
                    pt: 'Tempo médio da ideia até o mercado.',
                    en: 'Average time from idea to market.',
                }
            }
        ],
        products: [
            product(productsDetails[0].id, productsDetails[0].icon, productsDetails[0].name, productsDetails[0].description, productsDetails[0].about),
            product(productsDetails[1].id, productsDetails[1].icon, productsDetails[1].name, productsDetails[1].description, productsDetails[1].about),
            product(productsDetails[3].id, productsDetails[3].icon, productsDetails[3].name, productsDetails[3].description, productsDetails[3].about),
            product(productsDetails[2].id, productsDetails[2].icon, productsDetails[2].name, productsDetails[2].description, productsDetails[2].about),
            product(productsDetails[4].id, productsDetails[4].icon, productsDetails[4].name, productsDetails[4].description, productsDetails[4].about)
        ]
    },
    {
        id: 'disruption',
        colorClass: '.vivid03',
        bannerText: {
            pt: 'INOVAR. TRANSFORMAR. IMPACTO. REVOLUÇÃO. ÍMPETO.',
            en: 'INNOVATE. TRANSFORM. IMPACT. REVOLUTION. MOMENTUM.'
        },
        infos: [
            {
                title: {
                    pt: '+100M',
                    en: '+100M',
                },
                content: {
                    pt: 'Faturamento gerado através de soluções inovadoras.',
                    en: 'Revenue generated through innovative solutions.',
                }
            },
            {
                title: {
                    pt: '+22%',
                    en: '+22%',
                },
                content: {
                    pt: 'Aumento de receita com soluções disruptivas.',
                    en: 'Revenue growth driven by disruptive solutions.',
                }
            },
            {
                title: {
                    pt: '+85% NPS',
                    en: '+85% NPS',
                },
                content: {
                    pt: 'Clientes satisfeitos com nossa aliança.',
                    en: 'Customers satisfied with our alliance.',
                }
            }
        ],
        products: [
            product(productsDetails[3].id, productsDetails[3].icon, productsDetails[3].name, productsDetails[3].description, productsDetails[3].about),
            product(productsDetails[1].id, productsDetails[1].icon, productsDetails[1].name, productsDetails[1].description, productsDetails[1].about),
            product(productsDetails[2].id, productsDetails[2].icon, productsDetails[2].name, productsDetails[2].description, productsDetails[2].about),
            product(productsDetails[4].id, productsDetails[4].icon, productsDetails[4].name, productsDetails[4].description, productsDetails[4].about),
            product(productsDetails[0].id, productsDetails[0].icon, productsDetails[0].name, productsDetails[0].description, productsDetails[0].about)
        ]
    },
    {
        id: 'expansion',
        colorClass: '.vivid04',
        bannerText: {
            pt: 'CRESCER. ESCALAR. AMADURECER. ALCANÇAR. AMPLIAR. PROGREDIR. DESPONTAR.',
            en: 'GROW. SCALE. MATURE. REACH. EXPAND. ADVANCE. EXCEL.'
        },
        infos: [
            {
                title: {
                    pt: '+100M',
                    en: '+100M',
                },
                content: {
                    pt: 'Faturamento gerado com apoio dos nossos talentos.',
                    en: 'Revenue generated with the support of our talent.',
                }
            },
            {
                title: {
                    pt: '+34%',
                    en: '+34%',
                },
                content: {
                    pt: 'Economia de custos com a aliança tecnológica.',
                    en: 'Cost savings through our technological alliance.',
                }
            },
            {
                title: {
                    pt: '+85% NPS',
                    en: '+85% NPS',
                },
                content: {
                    pt: 'Clientes satisfeitos pela qualidade do serviço prestado.',
                    en: 'Customers satisfied with the quality of our service.',
                }
            }
        ],
        products: [
            product(productsDetails[4].id, productsDetails[4].icon, productsDetails[4].name, productsDetails[4].description, productsDetails[4].about),
            product(productsDetails[2].id, productsDetails[2].icon, productsDetails[2].name, productsDetails[2].description, productsDetails[2].about),
            product(productsDetails[3].id, productsDetails[3].icon, productsDetails[3].name, productsDetails[3].description, productsDetails[3].about),
            product(productsDetails[0].id, productsDetails[0].icon, productsDetails[0].name, productsDetails[0].description, productsDetails[0].about)
        ]
    }
]